/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-unused-expressions */
// This script initializes the Mapp script. The script will automatically
// send the data from `window._ti` to the Mapp server after loading.
// It is mostly a copy from https://github.com/danskernesdigitalebibliotek/dpl-cms/blob/develop/web/modules/custom/dpl_mapp/js/tiLoader.min.js
// The original script was provided by Piotr Birketoft from Mapp.
// The difference is that I added an id to the script tag to enable its removal later.

export const injectMappScript = ({ domain, id }) => {
  window._tiConfig = {
    tiDomain: domain,
    tiId: id,
    option: {}
  };

  (function (a, d, c, f) {
    a.wts = a.wts || [];
    var g = function (b) {
      var a = "";
      b.customDomain && b.customPath
        ? (a = b.customDomain + "/" + b.customPath)
        : b.tiDomain &&
          b.tiId &&
          (a =
            b.tiDomain +
            "/resp/api/get/" +
            b.tiId +
            "?url=" +
            encodeURIComponent("https://" + d.location.host + "/") +
            "&v=5");
      if (b.option)
        for (var c in b.option)
          a += "&" + c + "=" + encodeURIComponent(b.option[c]);
      return a;
    };
    if (-1 === d.cookie.indexOf("wt_r=1")) {
      var e = d.getElementsByTagName(c)[0];
      c = d.createElement(c);
      c.async = !0;
      c.id = "tiLoader";
      c.onload = function () {
        if ("undefined" !== typeof a.wt_r && !isNaN(a.wt_r)) {
          var b = new Date(),
            c = b.getTime() + 1e3 * parseInt(a.wt_r);
          b.setTime(c);
          d.cookie = "wt_r=1;path=/;expires=" + b.toUTCString();
        }
      };
      c.onerror = function () {
        "undefined" !== typeof a.wt_mcp_hide &&
          "function" === typeof a.wt_mcp_hide.show &&
          (a.wt_mcp_hide.show(), (a.wt_mcp_hide.show = function () {}));
      };
      c.src = "//" + g(f);
      e.parentNode.insertBefore(c, e);
    }
  })(window, document, "script", _tiConfig);
};

// Removes the Mapp script and its associated cookie to allow reinitialization
export const removeMappScript = () => {
  const script = document.getElementById("tiLoader");
  if (script) {
    script.parentNode.removeChild(script);
  }
  const cookie = document.cookie
    .split(";")
    .find((c) => c.trim().startsWith("wt_r="));
  if (cookie) {
    document.cookie =
      cookie + "; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  }
};
